import { render, staticRenderFns } from "./DialogAddRace.vue?vue&type=template&id=00c6648c&"
import script from "./DialogAddRace.vue?vue&type=script&lang=js&"
export * from "./DialogAddRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports